import Accordion from "react-bootstrap/Accordion";
import { pageTherapistsText } from "../../lib/constants";
import "./style/TherapistData.css";

export const TherapistData = ({ therapists }) => {
    return (
        <Accordion defaultActiveKey="0" className="therapist-accordion">
            {therapists.map(therapist => (
                <Accordion.Item eventKey={therapist.id} key={therapist.id}>
                    <Accordion.Header>{therapist.name}</Accordion.Header>
                    <Accordion.Body>
                    <strong>{pageTherapistsText.accordion_title_3}</strong>{" "}
                    {therapist.availability}
                    </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
};